import get from 'lodash.get';
import * as tracking from 'dibs-tracking';
import serverVars from 'server-vars';

import { getQueryParam } from '../../utils/uriUtils';
import { getSkuTrackingParams } from './helpers/getSkuTrackingParams';

const trackedProductDetailDimensions = [
    'onSale',
    'newListing',
    'dealerName',
    'dealerID',
    'dealerLocation',
    'itemPostingLocation',
    'purchaseStatus',
    'askingPrice',
    'priceType',
];

const {
    trackingConstants: { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_DETAIL },
    eventNameConstants: { EVENT_SELECT_ITEM, EVENT_VIEW_ITEM },
} = tracking;

function getDefaultTrackingFields(item) {
    const itemInfo = item.pdpTrackingVpvParams || {};
    const locale = serverVars.get('locale');
    const name = locale === 'en-US' ? itemInfo.itemName : 'n/a';

    return {
        brand: itemInfo.dealerId,
        category: item.browseUrl,
        categoryCode: item.categoryCode,
        dimension83: item?.contemporaryTrackingString || itemInfo?.contemporary,
        name,
        id: itemInfo.itemId,
    };
}

function trackEmailRecommendedItem(item) {
    const uriRef = get(global, 'location.search');
    const term = getQueryParam(uriRef, 'utm_term');

    /**
     * Tracks only if opened from transactional emails recommended items list.
     */
    if (term === 'recommendedItemsCarousel') {
        const list = 'email recommended items';

        tracking.trackEcommerce({
            type: ECOM_PRODUCT_CLICK,
            eventName: EVENT_SELECT_ITEM,
            actionField: { list, itemId: item.serviceId },
            products: [
                {
                    ...getDefaultTrackingFields(item),
                    variant: getQueryParam(uriRef, 'utm_campaign'),
                    list,
                },
            ],
        });
    }
}

export function trackEcommerce(item, skuId) {
    const pdpTrackingVpvParams = item.pdpTrackingVpvParams || {};
    const itemInfo = {
        ...pdpTrackingVpvParams,
        ...getSkuTrackingParams(pdpTrackingVpvParams, skuId),
    };
    tracking.trackEcommerce({
        type: ECOM_PRODUCT_DETAIL,
        eventName: EVENT_VIEW_ITEM,
        products: [
            {
                ...getDefaultTrackingFields(item),
                dimension12: itemInfo.dealerId,
                price: itemInfo.askingPrice,
                ...tracking.getCustomDimensions(itemInfo, trackedProductDetailDimensions),
            },
        ],
    });

    /**
     * Track ecommerce for items opened from email recommendations.
     */
    trackEmailRecommendedItem(item);
}

export function trackCarouselInteraction(action, image, totalImages, customLabel) {
    const label = customLabel || `${image + 1}/${totalImages}`; // adding 1 because we have 0 index
    tracking.trackEvent(
        {
            category: 'product',
            action,
            label,
            isInteractiveEvent: true,
        },
        null
    );
}

export function trackRelatedItems({
    visibleItem = {},
    listName,
    type,
    isUnpurchasable = false,
    eventName = 'na',
    variant = '',
}) {
    const item = visibleItem?.item?.node || visibleItem?.item || {};

    const {
        serviceId,
        categoryPath: category,
        contemporaryTrackingString: dimension83 = '',
        title: name,
        pricing,
        seller,
    } = item;

    const price = pricing?.retailPrice?.convertedAmounts?.USD || 0;
    const visibleItemIndex = visibleItem?.index || 0;
    const position = visibleItemIndex + 1; // 0 position is not relevant for tracking;
    const pdp = isUnpurchasable ? 'sold pdp' : 'pdp';
    const list = `${pdp} ${listName}`;
    const actionField = { list };

    if (eventName === EVENT_SELECT_ITEM) {
        actionField.itemId = item.serviceId;
    }

    tracking.trackEcommerce({
        type: type, //'productImpression' or 'productClick',
        actionField,
        eventName,
        products: [
            {
                brand: seller?.serviceId,
                category,
                dimension83,
                id: serviceId,
                list,
                name,
                position,
                price,
                ...(variant && { variant }),
            },
        ],
    });
}

export function trackSellerDetailsView(isNegotiable, isVisible) {
    if (isVisible) {
        tracking.trackEvent({
            category: 'product',
            action: 'below the fold reached - seller details',
            label: 'pdp',
        });
        if (isNegotiable) {
            tracking.trackEvent({
                category: 'product',
                action: 'embedded make offer module reached',
                label: 'pdp',
            });
        }
    }
}
